import { render, staticRenderFns } from "./AddNewStage.vue?vue&type=template&id=ad06340a"
import script from "./AddNewStage.vue?vue&type=script&lang=js"
export * from "./AddNewStage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports